import { initFlowbite } from 'flowbite';
import $ from 'jquery';

$(() => {
  let currentRequest = null;
  let latestInput = '';
  let requestSuccess = false;
  const debouncedFetchData = debounce(fetchData, 1000);

  $('#search-input').on('input', function () {
    if (window.innerWidth >= 768) {
      const value = $(this).val().trim();
      handleSearchInput(value);
    }
  });

  $('#search-input').on('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const value = $(this).val().trim();
      if (value) {
        window.location.href = `/search-result/?search=${encodeURIComponent(
          value
        )}`;
      }
    }
  });

  $('#search-input').on('focus', function () {
    if (window.innerWidth >= 768) {
      $('#search-result').removeClass('hidden').addClass('block');
      $('.screen-overlay').removeClass('hidden').addClass('block');
      // $('body').addClass('overflow-hidden');
    }
  });

  function handleSearchInput(value) {
    latestInput = value;
    $('.search-result-header').removeClass('block').addClass('hidden');
    $('.search-product-container').empty();
    if (value.length < 3) {
      $('#search-result .search-notification')
        .removeClass('hidden')
        .addClass('block');
      $('#search-result .loading-icon').removeClass('flex').addClass('hidden');
      return;
    }
    $('#search-result .search-notification')
      .removeClass('block')
      .addClass('hidden');
    debouncedFetchData(value);
  }

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  function fetchData(value) {
    if (currentRequest) {
      currentRequest.abort();
      currentRequest = null;
    }

    currentRequest = $.ajax({
      type: 'GET',
      url: ajax_object.ajax_url,
      data: { action: 'search_products', search: value },
      dataType: 'json',
      beforeSend: () => {
        $('#search-result .search-notification')
          .removeClass('block')
          .addClass('hidden');
        $('#search-result .loading-icon')
          .removeClass('hidden')
          .addClass('flex');
        $('.search-text').text(value);
        requestSuccess = false;
      },
      success: function (response) {
        if (response.success) {
          if (value === latestInput) {
            if (response.data.result != '') {
              $('.search-product-container').append(response.data.result);
              $('.search-result-header').removeClass('hidden').addClass('flex');
              $('.view-all-result').attr(
                'href',
                '/search-result?search=' + value
              );
              initFlowbite();
            } else {
              $('.search-product-container').html(
                '<div class="text-xl font-semibold text-#344E5C col-span-6 text-center">No results</div>'
              );
              $('.search-result-header').removeClass('flex').addClass('hidden');
            }
            requestSuccess = true;
          }
        }
      },
      error: function (jqXHR, textStatus, error) {
        if (textStatus === 'abort') {
          console.log('Request aborted');
        } else {
          console.error('Error search products: ', error);
        }
      },
      complete: function () {
        currentRequest = null;
        $('#search-result .loading-icon')
          .removeClass('flex')
          .addClass('hidden');
        if (!requestSuccess) {
          $('#search-result .search-notification')
            .removeClass('hidden')
            .addClass('block');
        }
      },
    });
  }

  $('.screen-overlay').on('click', function () {
    $('#search-result').removeClass('block').addClass('hidden');
    $(this).removeClass('block').addClass('hidden');
    // $('body').removeClass('overflow-hidden');
  });
});
